export const calendarMonthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const weekdaysShort = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];

export const MAX_PAST_MONTHS = 4;

export const disabledMonthMessage = `Date selection is limited to the past ${MAX_PAST_MONTHS} months.`;
